<template>
    <div class="CRUD" app>
        <Navbar />
        
        <v-content>
            <div style="margin: 10px 16px">
                <h1 :style="customization.dark ? 'color: white' : 'color: black'">Cadastro de {{title}}</h1>
                
                <v-card :dark="customization.dark">
                    <v-card-title>
                        <v-btn color="green" text @click="incluir">
                            <v-icon>mdi-plus</v-icon> Incluir
                        </v-btn>
                        <v-btn icon @click="filter">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-text-field
                            style="margin-left: 20px;transform: translateY(-10px)"
                            v-model="search"
                            label="Pesquisar"
                            @change="filter"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading" 
                        loading-text="Carregando... Por favor espere"
                        class="elevation-1"
                        hide-default-footer
                        :items-per-page="10"
                        :server-items-length="maxPages"
                        :page.sync="page"
                        @click:row="select"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template v-slot:item.deletado_veiculo="{ item }">
                            <v-icon>{{intToBool(item.deletado_veiculo) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"}}</v-icon>
                        </template>
                        <template v-slot:item.ATIVO="{ item }">
                            <v-icon>{{intToBool(item.ATIVO) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"}}</v-icon>
                        </template>
                        <template v-slot:item.evento="{ item }">
                            <v-icon>{{intToBool(item.evento) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"}}</v-icon>
                        </template>
                        <template v-slot:item.sos="{ item }">
                            <v-icon>{{intToBool(item.sos) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"}}</v-icon>
                        </template>
                        <template v-slot:item.active="{ item }">
                            <v-icon>{{intToBool(item.active) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"}}</v-icon>
                        </template>
                        <template v-slot:item.ativo="{ item }">
                            <v-icon>{{intToBool(item.ativo) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"}}</v-icon>
                        </template>
                        <template v-slot:item.datainicial="{ item }">
                            {{item.datainicial.split("-")[2]}}/{{item.datainicial.split("-")[1]}}/{{item.datainicial.split("-")[0]}}
                        </template>
                        <template v-slot:item.datafinal="{ item }">
                            {{item.datafinal.split("-")[2]}}/{{item.datafinal.split("-")[1]}}/{{item.datafinal.split("-")[0]}}
                        </template>
                        <template v-slot:item.cor="{ item }">
                            <span :style="`color: ${item.cor}`">{{item.cor}}</span>
                        </template>
                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-pagination :color="customization.mainBtnColor" v-model="page" :length="maxPages" total-visible="10" @input="getGrid"></v-pagination>
                    </div>
                </v-card>
            </div>
        </v-content>
    </div>
</template>

<script>
import Navbar   from '@/components/Navbar.vue';
import api      from '@/plugins/apisauceHeader.js';
import router   from '@/router/index.js';
import CRUD     from '@/assets/CRUD.json';

export default {
    name: 'CRUD',
    components:{
        Navbar
    },
    data: () => ({
        loading: true,
        items: [],
        search: "",
        dialog_remove: false,
        dialog: false,
        alert: "",
        page: 1,
        maxPages: 1,
        headers: [],
        customization: {},
        checkFields: [],
        nameType: "",
        endpoint: "",
        sortBy: null,
        sortDesc: null,
        orderBy: "",
        title: ""
    }),
    methods: {
        intToBool(i){
            return i == 1;
        },
        select(p){
            if(p[CRUD[this.nameType].id])
                router.push(`/View/${this.nameType}/${p[CRUD[this.nameType].id]}`);
        },
        getGrid(pagina){
            this.loading = true;
            if(this.sortBy != undefined && this.sortDesc != undefined){
                this.orderBy = `&orderby=${CRUD[this.nameType].orderBy[this.sortBy]}`;
                this.orderBy += this.sortDesc.toString() == "true" ? " DESC" : " ASC"
                if(this.orderBy.includes("undefined")) this.orderBy = "";
            }
            api(localStorage.getItem("token")).get(`endpoint${this.endpoint}?page=${pagina}&search=${this.search}${this.orderBy}`).then(r=>{
                if(r.ok){
                    this.items = r.data.endpoint;
                    this.maxPages = r.data.totalPages;
                }else
                    this.items = [];
                
                this.loading = false;
            });
        },
        incluir(){
            router.push(`/Create/${this.nameType}`);
        },
        filter(){
            this.getGrid(1);
        },
        loadPage(){
            this.sortBy = null;
            this.sortDesc = null;
            if(!localStorage.getItem("usrId")) router.push('/');
            this.nameType = this.$route.params.nameType;
            if(!CRUD[this.nameType]) router.push('/dashboard');
            this.headers = CRUD[this.nameType].headers;
            this.customization = JSON.parse(localStorage.getItem("customization"));
            this.title = `${CRUD[this.nameType].label ? CRUD[this.nameType].label : this.nameType}`;
            document.title = `${this.customization.name} - ${this.title}`;
            this.headers.forEach(h=>{
                switch(h.type){
                    case "check":
                        this.checkFields.push(h.value);
                }
            })
            this.endpoint = CRUD[this.nameType].needWhere ? `${CRUD[this.nameType].endpoint}/addwhere=idcliente:${localStorage.getItem("idcliente")}` : `${CRUD[this.nameType].endpoint}`;
            this.getGrid(1);
        }
    },
    watch: {
        '$route.params.nameType': function () {
            this.loadPage();
        },
        sortDesc(){
            this.getGrid(1);
        }
    },
    mounted(){
        this.loadPage();
    }
}
</script>